function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { NavSettings } from "../";

var FinderModuleAction = function (_Component) {
    _inherits(FinderModuleAction, _Component);

    function FinderModuleAction() {
        var _temp, _this, _ret;

        _classCallCheck(this, FinderModuleAction);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onEdit = function (props) {
            if (_this.props.onEdit) {
                _this.props.onEdit(props);
            }
        }, _this.onToggle = function (props) {
            if (_this.props.onToggle) {
                _this.props.onToggle(props);
            }
        }, _this.onAdd = function (props) {
            if (_this.props.onAdd) {
                _this.props.onAdd(props);
            }
        }, _this.onRemove = function (props) {
            if (_this.props.onRemove) {
                _this.props.onRemove(props);
            }
        }, _this.onSelect = function (props) {
            if (_this.props.onSelect) {
                _this.props.onSelect(props);
            }
        }, _this.onUnselect = function (props) {
            if (_this.props.onUnselect) {
                _this.props.onUnselect(props);
            }
        }, _this.onDelete = function (props) {
            if (_this.props.onDelete) {
                _this.props.onDelete(props);
            }
        }, _this.onRestore = function (props) {
            if (_this.props.onRestore) {
                _this.props.onRestore(props);
            }
        }, _this.onStar = function (props) {
            if (_this.props.onStar) {
                _this.props.onStar(props);
            }
        }, _this.getAction = function (action, index) {
            var _this$props = _this.props,
                url = _this$props.url,
                editUrl = _this$props.editUrl,
                refsUrl = _this$props.refsUrl,
                selected = _this$props.selected,
                starred = _this$props.starred,
                status = _this$props.status;


            if (action === "select" && selected || action === "unselect") {
                return {
                    type: "action",
                    icon: "check_circle",
                    label: "Ta bort",
                    intlLabel: "unselect",
                    onClick: function onClick() {
                        return _this.onUnselect(_this.props);
                    }
                };
            } else if (action === "select") {
                return {
                    type: "action",
                    icon: "check",
                    label: "Legg til",
                    intlLabel: "select",
                    onClick: function onClick() {
                        return _this.onSelect(_this.props);
                    }
                };
            }

            if (action === "add" && selected || action === "remove") {
                return {
                    type: "action",
                    icon: "remove_circle",
                    label: "Fjern",
                    intlLabel: "remove",
                    onClick: function onClick() {
                        return _this.onRemove(_this.props);
                    }
                };
            } else if (action === "add") {
                return {
                    type: "action",
                    icon: "add",
                    label: "Legg til",
                    intlLabel: "add",
                    onClick: function onClick() {
                        return _this.onAdd(_this.props);
                    }
                };
            }

            if (action === "toggle" && selected) {
                return {
                    type: "action",
                    icon: "check_circle",
                    label: "Ta bort",
                    intlLabel: "unselect",
                    onClick: function onClick() {
                        return _this.onUnselect(_this.props);
                    }
                };
            } else if (action === "toggle") {
                return {
                    type: "action",
                    icon: "check",
                    label: "Legg til",
                    intlLabel: "select",
                    onClick: function onClick() {
                        return _this.onSelect(_this.props);
                    }
                };
            }

            if (action === "edit" && _this.props.onEdit) {
                return {
                    type: "action",
                    icon: "edit",
                    label: "Rediger",
                    intlLabel: "edit",
                    onClick: function onClick() {
                        return _this.onEdit(_this.props);
                    }
                };
            } else if (action === "edit" && editUrl) {
                return {
                    type: "action",
                    icon: "edit",
                    label: "Rediger",
                    intlLabel: "edit",
                    url: editUrl
                };
            }

            if (action === "refs" && refsUrl) {
                return {
                    type: "action",
                    icon: "link",
                    label: "Lenker",
                    intlLabel: "refs",
                    url: refsUrl
                };
            }

            if (action === "view" && url) {
                return {
                    type: "action",
                    icon: "remove_red_eye",
                    label: "Vis",
                    intlLabel: "view",
                    url: url
                };
            }

            if (action === "delete" && status === "trash" || action === "restore") {
                return {
                    type: "action",
                    icon: "restore",
                    label: "Gjenopprett",
                    intlLabel: "restore",
                    onClick: function onClick() {
                        return _this.onRestore(_this.props);
                    }
                };
            } else if (action === "delete") {
                return {
                    type: "action",
                    icon: "delete",
                    label: "Slett",
                    intlLabel: "delete",
                    onClick: function onClick() {
                        return _this.onDelete(_this.props);
                    }
                };
            }

            return {
                type: "action",
                icon: "help"
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    FinderModuleAction.prototype.render = function render() {
        var action = this.props.action;


        if (!action) {
            return false;
        }

        if (!Array.isArray(action)) {
            return false;
        }

        var settings = action.map(this.getAction);

        if (!settings.length) {
            return false;
        }

        return React.createElement(NavSettings, { settings: settings });
    };

    return FinderModuleAction;
}(Component);

export default FinderModuleAction;